/**
 * Like Object.entries but returns the key as typed instead of string
 */
export const typedEntries = <T extends Record<PropertyKey, unknown>>(obj: T) =>
  Object.entries(obj) as [keyof T, T[keyof T]][];
